<template>
    <div :class="['input-container', { dark: theme == THEMES.DARK }, { small }]">
        <label v-if="label" class="input-label" :for="inputId">{{ label }}</label>
        <input
            v-if="type == 'file'"
            :id="inputId"
            :type="type"
            :disabled="disabled"
            accept="image/*,application/pdf"
            class="custom-input"
            @input="$emit('input', $event.target.files[0])"
        />
        <textarea
            v-else-if="type == 'textarea'"
            :id="inputId"
            :placeholder="placeholder"
            :disabled="disabled"
            class="custom-input textarea"
            @input="$emit('input', $event.target.value)"
        />
        <input
            v-else
            step="any"
            :type="type"
            :placeholder="placeholder"
            :value="value"
            :disabled="disabled"
            class="custom-input"
            @input="$emit('input', $event.target.value)"
        />
    </div>
</template>

<script>
import { mapState } from "vuex"

export default {
    props: {
        small: { type: Boolean, default: false },
        label: String,
        value: { type: [String, Number] },
        inputId: String,
        type: { type: String, default: "text" },
        placeholder: { type: String, default: "" },
        disabled: { type: Boolean, default: false },
    },
    model: {
        prop: "value",
        event: "input",
    },
    computed: {
        ...mapState("misc", ["theme", "THEMES"]),
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";
@import "@/assets/mixins.scss";

.input-container {
    margin-bottom: 0;
}

.input-label {
    display: block;
    font-size: 0.875rem;
    font-weight: 500;
    color: $textColor;
    margin-bottom: 6px;
}

.custom-input {
    display: block;
    width: 100%;
    padding: 8px 12px;
    font-size: 0.875rem;
    line-height: 1.5;
    color: $textColor;
    background-color: $lightCardBg;
    border: 1px solid $lightBorderColor;
    border-radius: 4px;
    transition: border-color 0.2s, box-shadow 0.2s;
    
    &:focus {
        border-color: $primaryColor;
        outline: none;
        @include focus-ring;
    }
    
    &::placeholder {
        color: rgba($textColor, 0.7);
        opacity: 1;
    }
    
    &:disabled {
        background-color: #f5f5f5;
        color: #999;
        cursor: not-allowed;
        opacity: 0.6;
    }
    
    &.textarea {
        min-height: 100px;
        resize: vertical;
    }
}

.small {
    .custom-input {
        padding: 6px 8px;
        font-size: 0.8125rem;
    }
}

/* Dark theme styling (ancestor `.dark`) */
:deep(.dark) .input-label {
    color: $darkTextColor;
}

:deep(.dark) .custom-input {
    background-color: $darkInputBg;
    border-color: $darkBorderColor;
    color: $darkTextColor;
    
    &:focus {
        border-color: $secondaryColorDark;
        @include focus-ring;
    }
    
    &::placeholder {
        color: rgba($darkTextColor, 0.7);
    }
    
    &:disabled {
        background-color: #2a2a2a;
        color: #666;
        cursor: not-allowed;
        opacity: 0.5;
    }
}
</style>
